import makeConcurrent from 'make-concurrent';
const limitConcurrency = (fn) => makeConcurrent(fn, { concurrency: 1 });
export default function filter(atom, predicate) {
    const get = limitConcurrency(async () => {
        const value = await atom.get();
        if (predicate(value)) {
            return value;
        }
        return new Promise((resolve) => {
            const unsubscribe = atom.observe((value) => {
                if (predicate(value)) {
                    unsubscribe();
                    resolve(value);
                }
            });
        });
    });
    const observe = (listener) => {
        return atom.observe((value) => {
            if (predicate(value)) {
                return listener(value);
            }
        });
    };
    return { ...atom, observe, get };
}
